module.exports = __webpack_public_path__ + "img/icon-messenger.c0a9ca56.svg";